<template>
  <div class="detail__profile">
    <div class="detail__profile__container">
      <p class="detail__profile__container--p">
        اطلاعات شخصی
      </p>
      <div class="detail__profile__container--info">
        <div class="con7">
          <div class="j1">
            <label for="">نام*</label>
            <input
              type="text"
              placeholder="نام"
              class="detail__profile__container--info-fname"
              :class="[per == false ? 'edit' : '']"
              v-model="info.fname"
              :readonly="per"
            />
          </div>

          <div class="j1">
            <label for="">نام خانوادگی*</label>
            <input
              type="text"
              placeholder="نام خانوادگی"
              class="detail__profile__container--info-lname"
              :class="[per == false ? 'edit' : '']"
              v-model="info.lname"
              :readonly="per"
            />
          </div>

          <div class="j1">
            <label for="">نام کاربری*</label>
            <input
              type="text"
              placeholder="نام کاربری"
              class="detail__profile__container--info-user"
              :class="[per == false ? 'edit' : '']"
              v-model="info.user"
              :readonly="per"
              style="direction:ltr"
            />
          </div>
        </div>
        <div class="con8">
          <div class="j3">
            <label for="">ایمیل</label>
            <input
              type="text"
              placeholder="ایمیل (اختیاری)"
              class="detail__profile__container--info-email"
              v-model="info.email"
              style="direction: ltr"
              :class="[per == false ? 'edit' : '']"
              :readonly="per"
            />
          </div>
          <!-- <div class="j3">
            <label for="">شماره همراه*</label>
            <input
              type="text"
              placeholder="شماره همراه"
              class="detail__profile__container--info-email"
              v-model="info.phoo"
              style="direction: ltr"
              :class="[per == false ? 'edit' : '']"
              :readonly="per"
            />
          </div> -->
        </div>

        <label class="checkbox">
          <span class="sss" v-if="info.wallet >= 0">
            موجودی کیف پول :
            {{ info.wallet.toLocaleString("fa").toPersianDigits() }}
            تومان</span
          >
          <span class="sss" v-if="info.wallet < 0">
            شما مبلغ
            {{ (info.wallet * -1).toLocaleString("fa").toPersianDigits() }}
            تومان بدهکار هستید</span
          >

          <!-- <input v-model="info.remail" type="checkbox" checked="checked" />
          <span class="checkmark"></span> -->
        </label>
        <label class="checkbox">
          <span class="ttt">دریافت اطلاعات از طریق ایمیل</span>
          <input v-model="info.remail" type="checkbox" checked="checked" />
          <span class="checkmark"></span>
        </label>
        <button
          @click.prevent="per = false"
          v-if="per"
          class="detail__profile__container-btn"
        >
          ویرایش اطلاعات*
        </button>
        <button
          v-if="!per"
          @click.prevent="send"
          class="detail__profile__container-btn"
        >
          تایید اطلاعات ویرایش شده
        </button>
        <!-- <input type="text" class="detail__profile__container--info-number" /> -->
        <!-- <input type="text" class="detail__profile__container--info-number" /> -->
      </div>
      <!-- <p class="detail__profile__container--p" style="margin-top:1em">
        ادرس ها و نشانی ها
      </p>
      <div class="detail__profile__container--info">
        <div class="con7">
          <input
            type="text"
            placeholder="استان"
            class="detail__profile__container--info-fname"
            :class="[per == false ? 'edit' : '']"
            v-model="info.pho"
            :readonly="per"
          />
          <input
            type="text"
            placeholder="شهر"
            class="detail__profile__container--info-lname"
            :class="[per == false ? 'edit' : '']"
            v-model="info.tpho"
            :readonly="per"
          />
          <input
            type="text"
            placeholder="کدپستی"
            class="detail__profile__container--info-lname"
            :class="[per == false ? 'edit' : '']"
            v-model="info.tpho"
            :readonly="per"
          />
        </div>
        <input
          type="text"
          placeholder="ادرس"
          class="detail__profile__container--info-email"
          :class="[per == false ? 'edit' : '']"
          v-model="info.tpho"
          :readonly="per"
        />
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      per: true,
      info: {
        remail: "",
        phoo: "",
        fname: "",
        lname: "",
        email: "",
        user: "",
        pho: "",
        wallet: "",
        tpho: ""
      }
    };
  },
  methods: {
    send() {
      function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      this.info.phoo = this.info.phoo
        .replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

      var that = this;
      this.$store.state.load = true;
      if (
        this.info.fname.length == 0 ||
        this.info.lname.length == 0 ||
        this.info.user.length == 0 ||
        this.info.phoo.length == 0
      ) {
        that.$toastr.e("لطفا فیلد های ضروری را پر کنید");
        that.$store.state.load = false;
      } else if (this.info.fname.length >= 150) {
        that.$toastr.e("طول نام وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.info.lname.length >= 150) {
        that.$toastr.e(
          "طول نام خانوادگی وارد شده نباید بیشتر از ۱۵۰ حرف باشد."
        );
        that.$store.state.load = false;
      } else if (this.info.user.length >= 150) {
        that.$toastr.e("طول نام کاربری وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      }
      //  else if (this.info.phoo.length != 11) {
      //   that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
      //   that.$store.state.load = false;
      // }
      else if (!validateEmail(this.info.email) && this.info.email != 0) {
        that.$toastr.e("لطفا ایمیل معتبر وارد کنید.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/profile/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile")
          },
          type: "PATCH",
          data: {
            first_name: this.info.fname,
            last_name: this.info.lname,
            username: this.info.user,
            email: this.info.email,
            // phone: this.info.pho,
            receive_email: this.info.remail
          },
          success: function(data, textStatus, request) {
            that.$toastr.s(data);
            that.$store.state.name = that.info.fname + " " + that.info.lname;
            localStorage.setItem(
              "name",
              that.info.fname + " " + that.info.lname
            );
          },
          error: function(request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function() {
            that.$store.state.load = false;
            that.per = true;
          }
        });
      }
    }
  },
  created() {
    this.$store.state.load = true;
    var that = this;
    String.prototype.toPersianDigits = function() {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function(w) {
        return id[+w];
      });
    };
    $.ajax({
      url: that.$store.state.url + "api/v1/accounts/profile/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile")
      },
      type: "GET",
      success: function(data, textStatus, request) {
        console.log(data);
        that.info.phoo = data.cellphone;
        that.info.fname = data.user.first_name;
        that.info.lname = data.user.last_name;
        that.info.email = data.user.email;
        that.info.user = data.user.username;
        that.info.remail = data.receive_email;
        that.info.wallet = data.wallet;
      },
      error: function(request, textStatus, errorThrown) {
        that.$toastr.e(request.responseJSON);
      },
      complete: function() {
        that.$store.state.load = false;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.j1 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    width: 93%;
    background: red;
    @media screen and (max-width: 600px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j2 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    width: 96%;
    // background: red;
    // background: red;
    @media screen and (max-width: 600px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}

.j3 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    width: 98%;
    // background: red;
    @media screen and (max-width: 600px) {
      width: 93%;
      font-size: 0.8em;
    }
  }
}
.detail__profile {
  width: 100%;
  height: auto;
  // background: red;
  margin-top: 7.9em;
  @media screen and (max-width: 600px) {
  }
  &__container {
    display: flex;
    flex-direction: column;
    direction: rtl;
    padding: 4em;
    justify-content: center;
    // align-items: center;
    @media screen and (max-width: 600px) {
      padding: 1em;
      font-size: 0.8em;
    }
    &-btn {
      text-decoration: none;
      border: none;
      padding: 1em;
      color: var(--main-color);
      background: var(--sub-color);
      font-family: "yekan";
      margin-top: 2em;
      border-radius: 8px;
      cursor: pointer;
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      // transform: translate(5.5%);
    }
    &--p {
      font-family: 0.9em;
      margin-bottom: 1em;
    }
    &--info {
      border-radius: 8px;
      background: var(--main-color);
      border: 1px solid rgb(194, 214, 219);
      height: auto;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.164);
      display: flex;
      flex-direction: column;
      padding: 1em;
      input {
        color: var(--font-color);
        font-family: "yekan";
        // width: auto;
        border: none;
        background: var(--bg-color);
        padding: 1em;
        margin: 1em;
        border-radius: 8px;
      }
      &-fname {
        width: 50%;
      }
      &-lname {
        width: 50%;
      }
    }
  }
}
.con7 {
  // background: red;
  width: 100%;
  display: flex;
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
}
.con8 {
  // background: red;
  width: 100%;
  display: flex;
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
}
.edit {
  background: var(--main-color) !important;
  border: 1px solid var(--sub-color) !important;
}
.checkbox {
  direction: rtl;
  display: flex;
  // justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin-bottom: 20px;
  cursor: pointer;
  margin-top: 0.8em;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  // background: red;
  width: 100%;
}

/* Hide the browser's default checkbox */
.checkbox input {
  direction: rtl;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-100%, 30%);
  border-radius: 2px;
  height: 15px;
  width: 15px;
  background-color: var(--main-color);
  border: 1px solid #ccc;
  direction: rtl;
  @media screen and (max-width: 800px) {
    width: 10px;
    height: 10px;
  }
  @media screen and (max-width: 500px) {
    width: 10px;
    height: 10px;
  }
}
.product_list__filters--container-check--title {
  @media screen and (max-width: 800px) {
    font-size: 0.8em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.6em;
  }
}
/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: var(--bg-color);
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: var(--shrink);
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  left: 5px;
  top: 3px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  @media screen and (max-width: 800px) {
    left: 3px;
    top: 1px;
    width: 2px;
    height: 5px;
  }
  @media screen and (max-width: 500px) {
    left: 3px;
    top: 1px;
    width: 2px;
    height: 5px;
  }
}
.ttt {
  margin-right: 3em;
  // margin-top: 1em;
  font-size: 0.9em;
  @media screen and (max-width: 500px) {
    // font-size: 0.6em;
    margin-top: 0.1em;
  }
}
.sss {
  margin-right: 1em;
  // margin-top: 1em;
  font-size: 0.9em;
  @media screen and (max-width: 500px) {
    // font-size: 0.6em;
    margin-top: 0.1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/userDetail/detail.vue